import { dataProvider, config } from "../../../studentportal-sdk";
import { utilityAndConfigStore, useLiveSession } from "../../store/zustand";

export const LiveClass = (props) => {
  const { asapceoApi } = dataProvider;

  const { setMessage } =
    utilityAndConfigStore((state) => ({
      setMessage: state.setMessage,
      startLoading: state.startLoading,
      stopALoadingProccess: state.stopALoadingProccess,
    }));

  const { liveClassDoc, setLiveClassDoc } =
    useLiveSession((state) => ({
      liveClassDoc: state.liveClassDoc,
      setLiveClassDoc: state.setLiveClassDoc
    }));

  const scheduleLiveClass = (data) => {
    (async () => {
      console.log({dt:data})
      const setLiveClass = await asapceoApi.scheduleLiveClass(data);

      setLiveClass?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.liveMessage.titleError,
          description: setLiveClass?.message,
          alert: true,
          inline: true,
        });

      setLiveClass?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.liveMessage.titleSuccess,
          description: config.constants.happyReport,
          alert: true,
          inline: true,
        });
    })();
  };

  const getLiveClass = () => {
    (async () => {
      const result = await asapceoApi.getLiveClass();
      result.data && setLiveClassDoc(result.data)
    })()
  }

  const updateLiveClass = () => {
    (async () => {
      const updateLiveSession = await asapceoApi.updateLiveClass();
      return updateLiveSession
    })()
  };
  return {
    store: {
      liveClassDoc
    },
    action: {
      setLiveClassDoc,
      scheduleLiveClass,
      updateLiveClass,
      getLiveClass
    },
  };
};
